import { Injectable } from '@angular/core';
import { KeyNameDto } from '@ex/core/common';
import { BehaviorSubject, filter } from 'rxjs';
import { ExtractPipe } from 'src/app/shared/pipes/extract.pipe';
import { ExtraMetric } from '../data-models/extra-metrics';
import { MetricDto } from '@ex/module/engagement/engagement-orgchart/data-access/models/metric-dto';
import { GeneralService } from './general.service';
import { AnalysisFilterKeys } from '../domain/analysis-filter-keys';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';
import { EssentialObjectService } from './essential-object.service';
import { Entity } from '../data-models/Entity';

export interface SurveyCriteriaDropdown {
    key: string,
    name: KeyNameDto[],
    options: any[],
    isCustom: boolean,
    isEntity?: boolean,
    value?: any,
    required?: boolean
}

@Injectable({
    providedIn: 'root'
})
export class CriteriaResolverService {
    readonly NA: string = 'txtNA';
    private allEntities: Entity[];
    entit
    constructor(private extractPipe: ExtractPipe, private generalService: GeneralService, private essentialObjectService: EssentialObjectService, private translatePipe: TranslatePipe) {
        this.essentialObjectService.essentialObject.pipe(filter(obj => !!obj.selectedEntity)).subscribe(obj => {
            this.allEntities = obj.allEntities;
        });
    }
    private surveyCriterias: SurveyCriteriaDropdown[] = [];

    private surveyCriteriasSubject = new BehaviorSubject<SurveyCriteriaDropdown[] | null>(null);
    surveyCriterias$ = this.surveyCriteriasSubject.asObservable();

    setSurveyCriterias(surveyCriterias: SurveyCriteriaDropdown[]) {
        this.surveyCriterias = surveyCriterias;
        this.surveyCriteriasSubject.next(this.surveyCriterias);
    }

    extractTranslation(data, criteriaKey, values, language) {
        let currentCriteria = this.surveyCriterias.find(cr => cr.key == criteriaKey);
        console.log(data);
        for (let index = 0; index < data.length; index++) {
            for (let ind = 0; ind < values.length; ind++) {
                let name = currentCriteria.options.find(x => x.key == data[index][values[ind]]).name;
                if (name)
                    data[index][values[ind]] = this.extractPipe.transform(name, language);
            }
        }
        return data;
    }

    extract(criteria: string, key: string, language: string, selectedEntityKey?: string) {

        if (!key || !criteria) {
            return "";
        }

        const surveyCriteria = this.surveyCriterias?.find(x => x.key === criteria);
        let parentEntityName = '';
        if (!surveyCriteria) return key;

        if (surveyCriteria.isEntity) {
            const entity = this.allEntities.find(x => x.key == key);
            const parentEntity = this.allEntities.find(x => x.key == entity?.parentKey);
            parentEntityName = this.extractPipe.transform(parentEntity?.name, language);
        }

        let option: any = surveyCriteria.options.find(x => x.key == key);
        // if nationlaity fall back to default list
        if (!option && criteria == AnalysisFilterKeys.Nationality.toUpperCase()) {

            const selectedEntity = this.allEntities.find(e => e.key === selectedEntityKey);
            console.log({ selectedEntity });

            const nationalityMetric = selectedEntity.metrics.find(n => n.key === AnalysisFilterKeys.Nationality.toUpperCase());
            option = nationalityMetric.options.find(x => x.key == key);
        }
        if (!option && criteria == AnalysisFilterKeys.Gender.toUpperCase()) {

            const selectedEntity = this.allEntities.find(e => e.key === selectedEntityKey);
            const genderMetric = selectedEntity.metrics.find(n => n.key === AnalysisFilterKeys.Gender.toUpperCase());
            option = genderMetric.options.find(x => x.key == key);
        }

        if ((!key && !option) || key == 'null' || key == 'NA') {
            return this.translatePipe.transform(this.NA, language, ModuleName.Shared);
        }
        return parentEntityName ? parentEntityName + ' - ' + this.extractPipe.transform(option?.name, language) : this.extractPipe.transform(option?.name, language) || key;
    }

    extractCriteria(criteria: string, language: string) {
        const surveyCriteria = this.surveyCriterias.find(x => x.key == criteria);

        if (!surveyCriteria) return criteria;

        return this.extractPipe.transform(surveyCriteria.name, language) || criteria;

    }


    extractCriteriaList(Metrics: any): SurveyCriteriaDropdown[] {

        const criteriaList: SurveyCriteriaDropdown[] = [];

        for (let criteria of Metrics) {

            switch (criteria.key) {

                case AnalysisFilterKeys.DateOfBirth:

                    const ageGroups = this.generalService.ageGroups_new;
                    const generation = this.generalService.generations_new

                    criteriaList.push({
                        ...this.generalService.fixedGroupingOptions.find(group => group.key == AnalysisFilterKeys.AgeGroups),
                        options: ageGroups
                    });

                    criteriaList.push({
                        ... this.generalService.fixedGroupingOptions.find(group => group.key == AnalysisFilterKeys.Generation),
                        options: generation
                    });

                    break;

                case AnalysisFilterKeys.DateOfJoining:

                    const tenureGroups = this.generalService.tenureGroups_new;

                    criteriaList.push({
                        ...this.generalService.fixedGroupingOptions.find(group => group.key == AnalysisFilterKeys.TenureGroups),
                        options: tenureGroups,
                    });

                    break;

                case AnalysisFilterKeys.DirectManagerId:
                    break;

                default:
                    criteriaList.push(criteria);
            }

        }

        return criteriaList;
    }


}
